import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface Props {
  readonly children?: ReactNode;
}

export default function PropertiesContainer({ children }: Props) {
  return <Box>{children}</Box>;
}
